var map = {
	"./1.png": 5445,
	"./2.png": 8718,
	"./3.png": 4503,
	"./4.png": 4888,
	"./5.png": 3281,
	"./6.png": 7034,
	"./7.png": 3219,
	"./8.png": 3028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3237;